import React from 'react'
import { ConfirmationDialog } from '../../Components/ConfirmationDialog'
import { CampaignSummary, setCampaignStatus } from '../../Api/campaigns'

interface State {
  isSubmitting: boolean
  hasError: boolean
}

interface InputProps {
  collectionId: string
  campaignInfo: CampaignSummary
  onClose: () => void
  onUpdated: () => void
}

export class CancelCampaignDialog extends React.Component<InputProps, State> {
  constructor(props: any) {
    super(props)
    this.state = {
      isSubmitting: false,
      hasError: false,
    }
  }
  render() {
    return (
      <ConfirmationDialog
        dialogTitle="Cancel Campaign"
        confirmationText={`Are you sure you want to cancel the campaign "${this.props.campaignInfo.title}"?`}
        errorMessage={
          this.state.hasError
            ? 'Could not cancel campaign. If the problem persist, please contact support.'
            : undefined
        }
        yesButtonText="Yes"
        noButtonText="No"
        isLoading={this.state.isSubmitting}
        onCancel={this.props.onClose}
        onConfirm={() => this.submit()}
      />
    )
  }
  submit() {
    this.setState({ isSubmitting: true })
    setCampaignStatus(
      this.props.collectionId,
      this.props.campaignInfo.id,
      'cancelled'
    )
      .then(this.props.onUpdated)
      .then(this.props.onClose)
      .catch((e) => {
        console.error(e)
        this.setState({ isSubmitting: false, hasError: true })
      })
    return false
  }
}
